<template>
  <div class="program">
    <div class="white-card">
      <div class="schedule card">
        <div class="title"></div>
        <div class="title">{{ $t('Program.title') }}</div>

        <div class="content">
<!--          <img src="../assets/img/meeting2.jpg" alt="">-->
<!--          <img src="../assets/img/meeting1.jpg" alt="">-->
          <!-- <img src="../assets/img/会议1.jpg" alt=""> -->
          <!-- <img src="../assets/img/会议2s.jpg" alt=""> -->
          <!-- <img :src="$t('Program.src1')" />
          <img :src="$t('Program.src3')" /> -->
          <div style="text-align: center;">

            <PDFJSViewer :path="`${path}`" :fileName="`${name}`"/>

          </div>
        </div>
      </div>
    </div>
  </div>
</template> 

<style lang="less">
.schedule {
  img {
    width: 80%;
    margin-left: 10%;
  }
}
</style>

<script>
import PDFJSViewer from './../components/PDFJSViewer'

export default {
  name: 'Program',
  components: {
    PDFJSViewer
  },
  data () {
    return {
      name: 'Program.pdf', // 这里是需要预览的 PDF 文件名
      path: 'lib/web/viewer.html'
    }
  }
};
</script>
